module.exports = __webpack_public_path__ + "static/Kumail.f3215346.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Kumail.jpg
// module id = 1306
// module chunks = 137408898365125